import fp from "fastify-plugin";
import type {
  FastifyInstance,
  FastifyPluginAsync,
  FastifyPluginOptions,
} from "fastify";
import { Queue } from "bullmq";
import { bullmqConnectionConfig } from "../config/bullmq.js";
import { startWhatsAppWorker } from "../workers/whatsapp.worker.js";

declare module "fastify" {
  interface FastifyInstance {
    whatsappQueue: Queue;
  }
}

const bullmqPlugin: FastifyPluginAsync = async (
  fastify: FastifyInstance,
  options: FastifyPluginOptions,
) => {
  const whatsappQueue = new Queue("whatsapp", {
    connection: bullmqConnectionConfig,
    defaultJobOptions: {
      attempts: 3,
      backoff: {
        type: "exponential",
        delay: 5000,
      },
      removeOnComplete: true,
      removeOnFail: false,
    },
  });

  const whatsappWorker = startWhatsAppWorker(fastify.prisma, fastify.log);

  fastify.decorate("whatsappQueue", whatsappQueue);

  fastify.addHook("onClose", async (instance) => {
    instance.log.info("Closing BullMQ workers...");
    await whatsappWorker.close();

    instance.log.info("Closing BullMQ queues...");
    await whatsappQueue.close();
  });
};

export default fp(bullmqPlugin, {
  name: "bullmq",
});
